<ng-template #modalLG let-modal>
    <div class="modal-header p-0" style="background-color: transparent;">
        <button type="button" class="close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div style="margin: 64px">
        <div class="modal-body p-0" tabindex="0" ngbAutofocus>
            <div class="text-center mb-2">
                <h5 style="font-size: 24px">{{ projectData ? 'Modifier le projet' : 'Ajoutez un projet' }}</h5>
                <p style="font-size: 15px" class="text-muted">Veuillez indiquer le nom associé au projet.</p>
            </div>
            <div class="center mb-2">
                <label>Nom du projet</label>
                <input type="text" class="form-control" placeholder="Entrez le nom du projet" [(ngModel)]="data.nom" name="nom">
            </div>
        </div>
        <div class="centerButtons">
            <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="!data.nom || !data.nom.trim()" rippleEffect>
                {{ projectData ? 'Modifier' : 'Valider' }}
            </button>
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" rippleEffect>Annuler</button>
        </div>
    </div>
</ng-template>
